import { apiUrl } from "../constans";
import apiClient from '../libs/axios';

const API_BASE = `${apiUrl}/v2/plans`;

const plan = {
    namespaced: true,
    state: {
        plans: [],
        planDetail: null,
        loading: false,
        error: null,
    },

    mutations: {
        setPlans(state, plans) {
            state.plans = plans;
        },

        setPlanDetail(state, plan) {
            state.planDetail = plan;
        },

        addPlan(state, plan) {
            state.plans.push(plan);
        },

        updatePlan(state, updatedPlan) {
            const index = state.plans.findIndex((item) => item.id === updatedPlan.id);
            if (index !== -1) {
                state.plans[index] = updatedPlan;
            }
            state.planDetail = updatedPlan;
        },

        removePlan(state, planId) {
            state.plans = state.plans.filter((item) => item.id !== planId);
        },

        clearPlanDetail(state) {
            state.planDetail = null;
        },

        setLoading(state, loading) {
            state.loading = loading;
        },

        setError(state, error) {
            state.error = error;
        },

        clearError(state) {
            state.error = null;
        },
    },

    actions: {
        async getPlansAction({ commit }) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.get(API_BASE);
                const data = response.data.data || response.data;
                commit('setPlans', data);
                return data;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al cargar planes');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async getPlanDetailAction({ commit }, planId) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.get(`${API_BASE}/${planId}`);
                const data = response.data.data || response.data;
                commit('setPlanDetail', data);
                return data;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al cargar detalle del plan');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async createPlanAction({ commit }, planData) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.post(API_BASE, planData);
                const data = response.data.data || response.data;
                commit('addPlan', data);
                return data;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al crear plan');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async updatePlanAction({ commit }, { planId, data }) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.put(`${API_BASE}/${planId}`, data);
                const result = response.data.data || response.data;
                commit('updatePlan', result);
                return result;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al actualizar plan');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async deletePlanAction({ commit }, planId) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.delete(`${API_BASE}/${planId}`);
                commit('removePlan', planId);
                return response.data;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al eliminar plan');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },
    },
};

export default plan;
